import { TableCell, TableRow } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

interface SkeletonRowProps {
  rows?: number;
  columns?: number;
}

const SkeletonRow = ({ rows = 5, columns = 4 }: SkeletonRowProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton variant='text' />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default SkeletonRow;
